import * as CheckoutFormatterV1 from "./v1/CheckoutFormatter";
import * as CheckoutFormatterV2 from "./v2/CheckoutFormatter";

export const CheckoutNormalizer = (checkoutType = "v2") =>
  checkoutType === "v1" ? CheckoutFormatterV1 : CheckoutFormatterV2;
